import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder } from "@/types";

export function useDeleteRemoveStakeholder() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const path = `companies/${currentCompanyId}/stakeholders/${id.toString()}`;
      const res = await guacHttpClient.delete<
        Stakeholder,
        HttpResponse<Stakeholder>
      >(path);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        ["stakeholders", currentCompanyId],
        (cachedData?: Stakeholder[]) => {
          if (!cachedData) return cachedData;
          return cachedData.filter(
            (stakeholder) => stakeholder.id !== variables.id,
          );
        },
      );
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["job-intake", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["companies-summary"],
      });
    },
  });
}
